import { FetchService } from '@/dmdrive/core/service/FetchService';
import { DriveFolder } from '@/dmdrive/drive/entities/DriveFolder';
import { DriveModel } from '@/dmdrive/drive/entities/DriveModel';
import { UpdateProjectValues } from '@/dmdrive/drive/types/ProjectValues';

export const PATH_DRIVE = '/api/drive';
export const PATH_UPLOAD = '/api/upload/dmcloud';
export const PATH_DRIVE_DMINDUSTRIAL = '/api/drive/dmind';

export class DriveAPI {
  fetchStructure() {
    return FetchService.get<DriveFolder[]>(`${PATH_DRIVE}/items`, {
      drive: 2,
      parent: null,
    });
  }

  uploadFile(file: File) {
    const body = new FormData();

    body.append('auto', file);

    return FetchService.post<DriveModel>(PATH_UPLOAD, { body, headers: { 'Content-Type': null } });
  }

  deleteProject(id: number) {
    return FetchService.remove(PATH_DRIVE, {
      body: [
        {
          id,
        },
      ],
    });
  }

  updateProject(id: number, body: Partial<UpdateProjectValues>) {
    return this.batchUpdate([
      {
        ...body,
        id,
      },
    ]);
  }

  batchUpdate(body: Any[]) {
    return FetchService.patch(PATH_DRIVE, {
      query: {
        drive: 2,
      },
      body,
    });
  }

  createDMIndustrialConference(sourceId: string, targetId: string) {
    return FetchService.post(PATH_DRIVE_DMINDUSTRIAL, {
      body: {
        conf1: sourceId,
        conf2: targetId,
      },
    });
  }
}
